<script setup lang="ts">
const props = defineProps({
    label: {
        type: String,
        default: '',
    },
    name: {
        type: String,
        default: '',
    },
    id: {
        type: String,
        default: '',
    },
    value: {
        type: String,
        default: '',
    },
    checked: {
        type: [String, Boolean],
        default: false,
    },
})

const emit = defineEmits(['update:checked'])

const proxyChecked = computed({
    get() {
        return props.checked
    },

    set(val) {
        emit('update:checked', val)
    },
})
</script>

<template>
    <input :id="id" v-model="proxyChecked" type="radio" name="reportReason" class="radio" :value="value" />
    <label :for="id" class="ml-2">
        <span></span>
        {{ label }}
    </label>
</template>

<style scoped lang="scss">
.radio {
    display: none;

    &--dark-label {
        color: $color-dark;
    }

    + label {
        display: flex;
        align-items: center;
        color: $color-dark;
        font-weight: 400;
        font-size: 14px;
        cursor: pointer;

        em {
            font-style: normal;
        }

        span {
            position: relative;
            display: inline-block;
            width: 15px;
            height: 15px;
            margin: 0 10px 0 0;
            vertical-align: middle;
            cursor: pointer;
            border-radius: 50%;
            background-color: $color-white;
            border: 1px solid $color-grey-semi-dark;
            transition: 200ms;

            &::after {
                content: '';
                position: absolute;
                top: -2px;
                left: -2px;
                display: block;
                width: calc(100% + 4px);
                height: calc(100% + 4px);

                border-radius: 50%;
                background-color: transparent;
                opacity: 0;
                transition: opacity 0.24s linear;
            }
        }
    }

    &:checked + label span {
        position: relative;
        background-color: $color-white;

        &::after {
            opacity: 1;
            border: 6px solid $color-cta;
        }
    }

    /** Green version **/
    &--green + label span {
        width: 21px;
        height: 21px;
    }

    &--green:checked + label span {
        &::after {
            border: 0;
            background-color: $color-green-dark;
            width: 13px;
            height: 13px;
            left: 3px;
            top: 3px;
        }
    }
}
</style>
